import { useState, useEffect } from 'react'
import { router } from '@inertiajs/react'
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useBasePath } from '@/lib/paths'

type Props = {
  business: { id: string; name: string }
  open: boolean
  onOpenChange: (open: boolean) => void
  basePath?: string
}

export function EditBusinessSheet({ business, open, onOpenChange, basePath: explicitBasePath }: Props) {
  const inferredBasePath = useBasePath()
  const basePath = explicitBasePath ?? inferredBasePath
  const [name, setName] = useState(business.name)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (open) setName(business.name)
  }, [open, business.name])

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setSubmitting(true)
    router.patch(`${basePath}/businesses/${business.id}`, { business: { name } }, {
      onSuccess: () => onOpenChange(false),
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="sm:max-w-lg overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Edit Business</SheetTitle>
          <SheetDescription>Update the business name</SheetDescription>
        </SheetHeader>

        <form onSubmit={handleSubmit} className="space-y-5 px-4">
          <div className="space-y-2">
            <Label htmlFor="name">Business Name</Label>
            <Input
              id="name"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="e.g. Acme Corp"
              required
              autoFocus
            />
          </div>

          <div className="flex gap-2">
            <Button type="submit" size="sm" disabled={submitting}>
              {submitting ? 'Saving...' : 'Save Changes'}
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
          </div>
        </form>
      </SheetContent>
    </Sheet>
  )
}
